import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function Companies() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/companies');
        setCompanies(data);
      } catch (e) {
        setError(e.response?.status
          ? `Failed to load companies (HTTP ${e.response.status}${e.response.data?.error ? ': ' + e.response.data.error : ''})`
          : 'Failed to load companies — is the backend running on :9091?');
      }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f172a' }}>Companies</h1>
      <p style={{ color: '#64748b', marginBottom: 20 }}>Client companies from the shared CLTS directory (read-only)</p>

      {error && <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>{error}</div>}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Loading...</div>
        ) : companies.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{error ? 'Could not load companies.' : 'No companies found.'}</div>
        ) : (
          <table>
            <thead>
              <tr><th>Name</th><th>Code</th><th>Status</th></tr>
            </thead>
            <tbody>
              {companies.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 600 }}>{c.name}</td>
                  <td>{c.code || '—'}</td>
                  <td>{c.status || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
